import React from "react";
import { IMAGES } from "../../data/mock";
import * as Icons from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export default function Benefits() {
  const { t } = useLang();
  return (
    <section id="why" className="relative pt-14 pb-24 md:py-32 bg-[var(--aa-cream)]">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <div className="reveal max-w-3xl">
          <div className="text-[11px] tracking-[0.24em] uppercase text-[var(--aa-wine)] font-semibold mb-4">
            {t.benefits.eyebrow}
          </div>
          <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.05] text-[var(--aa-ink)]">
            {t.benefits.h2a} <br className="hidden md:block" />
            <span className="italic">{t.benefits.h2b}</span>
          </h2>
          <p className="mt-6 text-[15px] md:text-lg text-[var(--aa-ink-soft)] max-w-2xl leading-relaxed">
            {t.benefits.p}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 md:gap-6">
          {t.benefits.items.map((b, i) => {
            const Ico = Icons[b.icon] || Icons.Star;
            return (
              <div
                key={i}
                className="reveal lift group relative rounded-3xl bg-white border border-[var(--aa-line)] p-7 md:p-9 overflow-hidden"
              >
                <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-[var(--aa-cream-warm)] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="relative flex items-center gap-3">
                  <span className="inline-flex items-center justify-center w-11 h-11 rounded-2xl bg-[var(--aa-wine)] text-[var(--aa-cream)]">
                    <Ico className="w-5 h-5" />
                  </span>
                  <span className="text-xs tracking-[0.18em] uppercase text-[var(--aa-wine)]/70">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="relative font-display text-2xl md:text-[28px] mt-6 text-[var(--aa-ink)] leading-tight">
                  {b.title}
                </h3>
                <p className="relative mt-3 text-[14.5px] text-[var(--aa-ink-soft)] leading-relaxed">
                  {b.body}
                </p>
              </div>
            );
          })}
        </div>

        <div className="reveal mt-16 md:mt-20 grid grid-cols-12 gap-4 md:gap-5">
          <div className="col-span-12 md:col-span-7 rounded-3xl overflow-hidden aspect-[16/10] relative">
            <img src={IMAGES.pool} alt="Resort pool" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
          </div>
          <div className="hidden md:block col-span-6 md:col-span-5 rounded-3xl overflow-hidden aspect-[4/5] relative">
            <img src={IMAGES.dinner} alt="Longtail boat island tour, Koh Samui" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
          </div>
        </div>
      </div>
    </section>
  );
}
